import React from 'react';
import { Link } from 'react-router-dom';
import { Bitcoin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2A2A33] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Bitcoin className="h-8 w-8 text-[#006AFF]" />
              <span className="text-2xl font-bold text-white">AssumeRate</span>
            </div>
            <p className="text-sm text-gray-400">
              Access distressed assets using your Bitcoin or Ethereum as collateral. No selling required. Tax-efficient. Lightning fast approval.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/marketplace" className="text-gray-400 hover:text-white transition-colors">Marketplace</Link></li>
              <li><Link to="/calculator" className="text-gray-400 hover:text-white transition-colors">Loan Calculator</Link></li>
              <li><Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors">How It Works</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Asset Categories</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/marketplace?category=cre" className="text-gray-400 hover:text-white transition-colors">Commercial Real Estate</Link></li>
              <li><Link to="/marketplace?category=foreclosure" className="text-gray-400 hover:text-white transition-colors">Foreclosure Assets</Link></li>
              <li><Link to="/marketplace?category=airplane" className="text-gray-400 hover:text-white transition-colors">Aircraft</Link></li>
              <li><Link to="/marketplace?category=company" className="text-gray-400 hover:text-white transition-colors">Companies</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <span>support@assumerate.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4" />
                <span>1-800-ASSUME-1</span>
              </li>
              <li className="flex items-center space-x-2">
                <MapPin className="h-4 w-4" />
                <span>New York, NY</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-sm text-center text-gray-500">
          <p>&copy; 2025 AssumeRate. All rights reserved. | Terms of Service | Privacy Policy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
